// src/api/authApi.js
import axios from "axios";

// Normalize base URL (works with or without trailing slash)
const BASE = process.env.REACT_APP_API_BASE_URL.replace(/\/+$/, "");

// Single source of truth for keys
export const TOKEN_KEY = "authToken";
export const DEMO_KEY = "isDemo";

// Shared axios instance
export const api = axios.create({ baseURL: BASE });

// Attach JWT on every request (if present)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Global auth/demo handling
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const { status, data } = err.response || {};
    if (status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(DEMO_KEY);
      localStorage.removeItem("userPermissions");
      localStorage.removeItem("userRole");
      if (typeof window !== "undefined") window.location.assign("/signin");
    } else if (status === 403 && data?.error === "DEMO_READ_ONLY") {
      // eslint-disable-next-line no-alert
      alert("Demo mode: create/update/delete actions are disabled.");
    }
    return Promise.reject(err);
  }
);

// === Auth APIs ===
export const loginUser = async (email, password) => {
  const { data } = await api.post("/api/auth/login", { email, password });
  return data; // { token, ... }
};

export const registerUser = async (email, password) => {
  const { data } = await api.post("/api/auth/register", { email, password });
  return data;
};

// Demo token for read-only preview
export const getDemoToken = async () => {
  const { data } = await api.post("/api/auth/demo-token");
  return data; // { token }
};

// Helpers
export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(DEMO_KEY);
  localStorage.removeItem("userPermissions");
  localStorage.removeItem("userRole");
};

